import { jwtDecode } from 'jwt-decode';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../App/redux/store';
import LocalStorageService from '../../services/localStorageService';
import useQuery from '../../utils/useQuery';
import { authActions, getAuthState } from './authSlice';
import { fetchAuthUserThunk, logoutThunk } from './services/authThunks';
interface IUseAuthProps {
  loadUser?: boolean;
}
const useAuth = ({ loadUser = false }: IUseAuthProps) => {
  const query = useQuery();
  const queryToken = query.get('token');
  const {
    userIdIri,
    isManager,
    isAdmin,
    isLogged,
    user,
    maintenancePageOnly,
    token,
    refreshToken,
  } = useAppSelector(getAuthState);
  const dispatch = useAppDispatch();

  const initAuth = () => {
    if (!(token && refreshToken && userIdIri)) {
      const rt = LocalStorageService.getRefreshToken();
      const t = LocalStorageService.getToken();

      if (t && rt) {
        const decodedToken = jwtDecode<TokenType>(t);
        if (decodedToken) {
          const userIdIri = `/users/${decodedToken.user_id}`;

          dispatch(
            authActions.setTokens({
              token: t,
              refreshToken: rt,
              userIdIri,
            }),
          );
        }
      }
    }

    if (token && userIdIri) {
      dispatch(fetchAuthUserThunk({ userIdIri }));
    }
  };

  useEffect(() => {
    if (!maintenancePageOnly) {
      if (queryToken) {
        // if change password token from mail link
        // dispatch(authActions.logout.request());
        dispatch(logoutThunk());
      } else if (loadUser && !isLogged) {
        initAuth();
      }
    }
  }, [loadUser, maintenancePageOnly, queryToken, isLogged, token, userIdIri]);

  return {
    isLogged,
    user: user.result,
    userApiStatus: user.apiStatus,
    userIdIri,
    userFullName: user.result?.fullName ?? null,
    userFullNameWithInitial: user.result?.fullNameWithInitial ?? null,
    userInitials: user.result?.initials ?? null,
    isManager: isManager,
    isAdmin: isAdmin,
    role: !user.result
      ? null
      : user.result.roles.includes('ROLE_ADMIN')
      ? 'Admin'
      : user.result.roles.includes('ROLE_MANAGER')
      ? 'Manager'
      : 'Prospecteur',
    maintenancePageOnly,
  };
};

export default useAuth;
